import PET_CONFIG from 'config/pet.config';
import { date } from 'utils/date';

export function sortNotes(notes) {
  const special = notes.filter(
    (n) => n.noteTypeId === PET_CONFIG.noteTypeId.specialBreeder
  );
  const circumstances = notes.filter(
    (n) => n.noteTypeId === PET_CONFIG.noteTypeId.circumstantialBreeder
  );
  const internal = notes.filter(
    (n) => n.noteTypeId === PET_CONFIG.noteTypeId.internal
  );
  const internalSortedByDate = internal.sort((a, b) => {
    return (
      new Date(b.updatedAt) || new Date() - new Date(a.updatedAt) || new Date()
    );
  });

  return [...special, ...circumstances, ...internalSortedByDate];
}

export function formatInternalNote(note) {
  note.label = 'Internal';
  note.formattedDate = date.toUsLocaleWithTime(note.updatedAt);

  return note;
}

function filterNotesForNotesTab(notes, listingId) {
  return notes.filter((note) => {
    const isInternalNote = note.noteTypeId === PET_CONFIG.noteTypeId.internal;
    const isNoteInListing = note.noteableId === listingId;
    if (isInternalNote && isNoteInListing) {
      formatInternalNote(note);
      return true;
    }

    const isSpecialBreederNote =
      note.noteTypeId === PET_CONFIG.noteTypeId.specialBreeder;
    if (isSpecialBreederNote) {
      note.label = 'Special';
      return true;
    }

    const isCircumstantialBreeder =
      note.noteTypeId === PET_CONFIG.noteTypeId.circumstantialBreeder;
    if (isCircumstantialBreeder) {
      note.label = 'Circumstances';
      return true;
    }

    return false;
  });
}

export function getNotesFromListing(listing) {
  let notes = [
    ...(listing?.notes || []),
    ...(listing?.puppy?.notes || []),
    ...(listing?.breeder?.notes || []),
  ];
  notes = filterNotesForNotesTab(notes, listing.id);
  notes = sortNotes(notes);

  return notes;
}
